import React, { createContext } from 'react';

export const AppContext = createContext();
export const ProfileSliderContext = createContext();
export const WalletContext = createContext();

// export default AppContext;
